export default __webpack_public_path__ + "static/media/McAfee.8500d13d.png";